<template>
  <div class="change-fee-table">
    <!-- 搜索栏 -->
    <el-card shadow="hover" class="search-card">
      <el-form :inline="true" size="small">
        <el-form-item label="电表编码">
          <el-input v-model="searchForm.search" placeholder="请输入工单编号或电表编码" clearable style="width: 250px;"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable style="width: 150px;">
            <el-option label="全部" value=""></el-option>
            <el-option label="已完成" value="completed"></el-option>
            <el-option label="进行中" value="processing"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="创建工单时间范围">
          <el-date-picker v-model="searchForm.searchDayTimeRange" type="datetimerange" align="right" start-placeholder="开始日期"
            end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card shadow="hover" class="table-card">
      <el-table :data="tableData" border stripe highlight-current-row row-key="id" style="width: 100%;"
        height="calc(100vh - 280px)">
        <el-table-column prop="ID" label="ID" width="160" align="center"></el-table-column>
        <el-table-column prop="old_feetable_address" label="旧表编码" width="120" align="center"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="new_feetable_address" label="新表编码" width="120" align="center"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="merchant_name" label="运营商名称" width="160" align="center"
          show-overflow-tooltip></el-table-column>
        <el-table-column prop="site_name" label="所属站点" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="create_time" label="更换时间" width="170" align="center"></el-table-column>
        <el-table-column prop="user_name" label="操作人员" width="120" align="center"
          show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="oldBalance" label="旧表余额" width="110" align="right">
          <template slot-scope="scope">¥{{ scope.row.oldBalance }}</template>
</el-table-column> -->
        <el-table-column prop="newBalance" label="新表余额" width="110" align="right">
          <template slot-scope="scope">
            <span :class="{ 'highlight-green': true }">¥{{ formatReading(scope.row.send_dev_balance / 100) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="oldReading" label="旧表底表值" width="140" align="right">
          <template slot-scope="scope">{{ formatReading(scope.row.cur_meter / 1000) }} kWh</template>
        </el-table-column>
        <el-table-column prop="newReading" label="新表底表值" width="140" align="right">
          <template slot-scope="scope">{{ getNewReading(scope.row) }} kWh</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <span :class="scope.row.is_finished ? 'status-completed' : 'status-processing'">{{ scope.row.is_finished ?
              '已完成' : '进行中' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="total" :page-size="pageSize"
          :page-sizes="[10, 20, 50, 100]" :current-page="currentPage" @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-card>

    <!-- 换表详情抽屉 -->
    <change-fee-table-details ref="detailsRef" :visible.sync="drawerVisible" :change-data="selectedChange" />
  </div>
</template>

<script>
import ChangeFeeTableDetails from './components/changeFeeTableDetails.vue'

import {
  getFeetableSwitchPageListApi
} from '@/api/dev_archive';
import { formatDate } from "@/utils/tools.js";

export default {
  name: 'ChangeFeeTable',
  components: {
    ChangeFeeTableDetails
  },
  data() {
    return {
      searchForm: {
        oldTableCode: '',
        newTableCode: '',
        search: '',
        status: '',
        searchDayTimeRange: ''
      },
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      drawerVisible: false,
      selectedChange: null
    }
  },
  mounted() {
    this.loadTableData()
  },
  methods: {
    formatReading(val) {
      if (val === null || val === undefined || val === '') return '0.0';
      return Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getNewReading(rowData){
      if(rowData.has_send_meter_dq && rowData.new_cur_meter ===0 && rowData.cur_meter > 0){
        return this.formatReading(rowData.cur_meter / 1000)
      } else {
        return this.formatReading(rowData.new_cur_meter / 1000)
      }
    },
    // 加载表格数据
    loadTableData() {
      let requestData = {
        page: this.currentPage,
        pagesize: this.pageSize
      }
      if (this.searchForm.search && this.searchForm.search.trim().length > 0) {
        requestData.search = this.searchForm.search
      }
      if (this.searchForm.status === 'completed') {
        requestData.is_finished = true;
      } else if (this.searchForm.status === 'processing') {
        requestData.is_finished = false;
      }
      if(this.searchForm.searchDayTimeRange && Array.isArray(this.searchForm.searchDayTimeRange) && this.searchForm.searchDayTimeRange.length === 2){
        requestData.start_time = formatDate(this.searchForm.searchDayTimeRange[0]);
        requestData.end_time = formatDate(this.searchForm.searchDayTimeRange[1]);
      }

      getFeetableSwitchPageListApi(requestData).then((res) => {
        // onsole.log(res)
        this.tableData = res.data || [];
        this.total = res.total;
      })
    },

    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.loadTableData()
    },

    // 显示详情
    showDetail(row) {
      this.selectedChange = row;
      this.$refs.detailsRef.initData(row);
      this.drawerVisible = true
    },

    // 每页条数变化
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadTableData()
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.currentPage = val
      this.loadTableData()
    }
  }
}
</script>

<style scoped lang="scss">
.change-fee-table {
  height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  overflow: hidden;
  box-sizing: border-box;
}

.search-card {
  flex-shrink: 0;

  ::v-deep .el-card__body {
    padding: 12px 16px;
  }
}

.table-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;

  ::v-deep .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 12px;
    overflow: hidden;
  }
}

.pagination-container {
  margin-top: 12px;
  text-align: right;
  flex-shrink: 0;
}

// 高亮绿色
.highlight-green {
  color: #67C23A;
  font-weight: 600;
}

// 状态颜色
.status-completed {
  color: #67C23A;
  font-weight: 500;
}

.status-processing {
  color: #F56C6C;
  font-weight: 500;
}
</style>